import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'
import Link from 'components/Link'
import { DevErrorViewContext } from 'components/Errors/DevErrorView'

const DEV_TEST_DATA = {
    bos: {
        parentVehicle: {
            vehicleId: 12345,
        }
    }
}

const BosTrafiOwnerChangedMessage = ({ appError }) => {
    const { t, i18n } = useTranslation(['bosCreate', 'errors'])

    const devErrorContext = useContext(DevErrorViewContext)

    let data = appError.data

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    return (
        <ErrorMessageContent
            title={t('errors:omanettix.10050.title')}
            content={(
                <p>
                    {t('errors:omanettix.10050.message')}
                </p>
            )}
            actions={(
                <Link
                    className="button"
                    trackName="createBillOfSale"
                    to={data.bos && data.bos.parentVehicle
                        ? `${getLocale(i18n.language)}/ajoneuvo/${data.bos.parentVehicle.vehicleId}/luo-sahkoinen-kauppakirja`
                        : `${getLocale(i18n.language)}/luo-sahkoinen-kauppakirja`}
                >
                    {t('createBillOfSale:title')}
                </Link>
            )}
        />
    )
}

export default BosTrafiOwnerChangedMessage
